/* Pause control for the photo carousel (the motion itself is CSS). Hidden for reduced motion, where nothing moves. */
class LurenMarquee extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-marquee-toggle]');
    if (!this.toggle || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.controller = new AbortController();
    this.toggle.hidden = false;
    this.toggle.addEventListener(
      'click',
      () => {
        this.toggleAttribute('data-paused');
        this.toggle.textContent = this.hasAttribute('data-paused') ? this.dataset.playLabel : this.dataset.pauseLabel;
      },
      { signal: this.controller.signal }
    );
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('luren-marquee')) customElements.define('luren-marquee', LurenMarquee);
